<div class="main-container">
    <app-spinner [state]="loading"></app-spinner>
    <app-toastr [properties]="alertProperties" *ngIf="showAlert"></app-toastr>
    <div class="policy-info-section">
        <div class="card policy-info-card">
            <div class="card-header">
                <h2>Policy Info</h2>
            </div>
            <div class="card-body">
                <div class="info-item">
                    <label>Owner NRIC</label>
                    <span>{{ quotationDetail?.customer?.nric }}</span>
                </div>
                <div class="info-item">
                    <label>Vehicle</label>
                    <span>{{ quotationDetail?.customerVehicle?.brand }} {{ quotationDetail?.customerVehicle?.model }}</span>
                </div>
                <div class="info-item">
                    <label>Vehicle Reg. Num</label>
                    <span>{{ quotationDetail?.customerVehicle?.plateNumber }}</span>
                </div>
                <div class="info-item">
                    <label>Year</label>
                    <span>{{ quotationDetail?.customerVehicle?.manufactureYear }}</span>
                </div>
                <div class="info-item">
                    <label>Insurance Type</label>
                    <span>{{ quotationDetail?.insuranceType || '-' }}</span>
                </div>
                <div class="info-item">
                    <label>NCD</label>
                    <span>{{ quotationDetail?.customerVehicle?.ncd || '-' }}%</span>
                </div>
                <div class="info-item">
                    <label>E-Hailing</label>
                    <span>{{ quotationDetail?.customerVehicle?.isEhailing ? 'Yes' : 'No' }}</span>
                </div>
                <div class="info-item">
                    <label>Policy Effective From</label>
                    <span> {{ quotationDetail?.customerVehicle?.currentInsuranceExpirationDate | date:'dd MMM yyyy' }} - {{ insuranceDateTo ? (insuranceDateTo | date:'dd MMM yyyy') : '' }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="pricing-section" *ngIf="!selectedProvider">
        <div class="card pricing-card" *ngFor="let provider of quotationDetail?.quotationInsuranceProviderList">
            <div class="card-header">
                <h2>{{ provider.insuranceProvider.name }}</h2>
                <p class="sub-price">{{ provider.insuranceProvider.email }}</p>
                <p class="price">RM {{ provider.basicPremium | number:'1.2-2' }}</p>
            </div>
            <ul class="card-features" *ngIf="provider.insuranceProvider.insuranceProviderBenefitList?.length > 0">
                <li *ngFor="let benefit of provider.insuranceProvider.insuranceProviderBenefitList">
                    {{ benefit.benefit }}
                </li>
            </ul>
            <ul class="card-breakdown">
                <li>Basic Premium:
                    <strong>RM {{ provider.basicPremium | number:'1.2-2' }}</strong>
                </li>
                <li>Premium Due (after NCD {{ quotationDetail.customerVehicle.ncd }}%):
                    <strong>RM {{ computePremiumDue(provider.basicPremium) | number:'1.2-2' }}</strong>
                </li>
                <li *ngIf="quotationDetail?.insuranceType !== 'Lump Sum'">SST ({{ sstRate * 100 | number:'1.0-0' }}%):
                    <strong>RM {{ computeSst(provider.basicPremium) | number:'1.2-2' }}</strong>
                </li>
                <li *ngIf="quotationDetail?.insuranceType !== 'Lump Sum'">Service Charge:
                    <strong>RM {{ (quotationDetail?.serviceCharge || 0) | number:'1.2-2' }}</strong>
                </li>
                <li class="total">Total Price:
                    <strong>RM {{ computeTotal(provider.basicPremium) | number:'1.2-2' }}</strong>
                </li>
            </ul>
            <div class="card-footer">
                <button class="btn select-btn" (click)="selectPlan(provider)">Select Plan</button>
            </div>
        </div>
    </div>
    <div *ngIf="selectedProvider" class="configuration-panel">
        <div class="config-header centered">
            <button class="btn" (click)="cancelSelection()">← Back</button>
            <h3 class="config-title">Configure your plan — {{ selectedProvider.insuranceProvider.name }}</h3>
        </div>
        <div class="addons-center">
            <div class="roadtax-card" *ngIf="quotationDetail?.insuranceType !== 'Lump Sum'">
                <div class="card-header">
                    <h3>Roadtax</h3>
                    <div class="price-badge">RM {{ (quotationDetail?.roadtaxPrice || 0) | number:'1.2-2' }}</div>
                </div>
                <div class="card-body">
                    <p class="question">Do you want <strong>Roadtax</strong>?</p>
                    <div class="toggle-group">
                        <button type="button" class="toggle-btn" [class.active]="roadtaxYes === true" (click)="selectRoadtax(true)">Yes</button>
                        <button type="button" class="toggle-btn" [class.active]="roadtaxYes === false" (click)="selectRoadtax(false)">No</button>
                    </div>
                    <div class="roadtax-options" *ngIf="roadtaxYes">
                        <label class="checkbox-wrapper" *ngIf="quotationDetail?.customerVehicle?.isEhailing === false">
                            <input type="radio" name="roadtaxOption" [(ngModel)]="roadtaxOption" value="digital" id="digitalRoadtax" />
                            <span class="custom-checkbox"></span>Digital (RM {{ (quotationDetail?.roadtaxDigitalCharge || 0) | number:'1.2-2'}})
                        </label>
                        <p class="description" *ngIf="quotationDetail?.customerVehicle?.isEhailing === false">View roadtax on MyJPJ app. NO roadtax sticker. Renew in <span class="highlight">1 Working Day!</span></p>
                        <label class="checkbox-wrapper">
                            <input type="radio" name="roadtaxOption" [(ngModel)]="roadtaxOption" value="physical" id="physicalRoadtax" />
                            <span class="custom-checkbox"></span>Physical (Delivery RM {{ (quotationDetail?.roadtaxDeliveryCharge || 0) | number:'1.2-2'}})
                        </label>
                        <p class="description">Roadtax sticker will be printed and delivered. Delivery time 5–7 working days</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="addons-center" *ngFor="let addon of selectedProvider.quotationAddOnsPoco">
            <div class="roadtax-card">
                <div class="card-header">
                    <h3>{{ addon?.refQuotationAddOnsType?.name }}</h3>
                    <div class="price-badge">RM {{ (addon.price || 0) | number:'1.2-2' }}</div>
                </div>
                <p class="addon-question">Do you want coverage for <strong>{{ addon?.refQuotationAddOnsType?.name }}</strong>?</p>
                <div class="card-body" *ngIf="isSpecialInputAddon(addon)">
                    <label>Please key in sum insured</label>
                    <div class="sum-input">
                        <span class="currency-label">RM</span>
                        <input type="number" (ngModelChange)="onSumInsuredChanged(addon, $event)" [ngModel]="addon.sumInsuredInput" [min]="getMinSumInsured(addon)" [placeholder]="'e.g. ' + getMinSumInsured(addon)" placeholder="e.g. 3000" />
                    </div>
                    <small class="note">
                        <strong>Note:</strong> Sum insured starts from RM {{ getMinSumInsured(addon) }}.
                        To determine the value required, please refer to your car manufacturer or any of our panel workshops for an estimated cost.
                        </small>
                </div>
                <div class="card-body">
                    <div class="toggle-group">
                        <button *ngIf="isSpecialCheckAddon(addon)" type="button" class="toggle-btn" [class.active]="addon.isSelected === true" (click)="toggleAddon(addon, true)">Yes</button>
                        <button *ngIf="!isSpecialCheckAddon(addon)" type="button" class="toggle-btn" [class.active]="addon.isSelected === true" (click)="toggleAddon(addon, true)">Yes</button>
                        <button type="button" class="toggle-btn" [class.active]="addon.isSelected === false" (click)="toggleAddon(addon, false)">No</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="addons-center">
            <div class="policy-summary-card">
                <div class="card-header centered">
                    <h3 class="config-title">Your Policy</h3>
                </div>
                <div class="card-body">
                    <div class="info-item">
                        <label>Cover Type</label>
                        <span>{{ quotationDetail.insuranceType }}</span>
                    </div>
                    <div class="info-item">
                        <label>Basic Premium</label>
                        <span>RM {{ (selectedProvider.basicPremium || 0) | number:'1.2-2' }}</span>
                    </div>
                    <div class="info-item">
                        <label>NCD ({{ quotationDetail.customerVehicle.ncd }}%)</label>
                        <span>-RM {{ (selectedProvider.basicPremium * quotationDetail.customerVehicle.ncd/100) | number:'1.2-2' }}</span>
                    </div>
                    <div class="info-item total">
                        <label>Gross Premium</label>
                        <span>RM {{ computeGrossPremium(selectedProvider.basicPremium) | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
            <div class="policy-summary-card" *ngIf="quotationDetail?.insuranceType !== 'Lump Sum'">
                <div class="card-header centered">
                    <h3 class="config-title">Additional Benefits</h3>
                </div>
                <div class="card-body">
                    <div class="info-item" *ngIf="quotationDetail.llop">
                        <label>L.L.O.P.</label>
                        <span>RM {{ (quotationDetail.llop || 0) | number:'1.2-2' }}</span>
                    </div>
                    <div class="info-item" *ngFor="let addon of additionalBenefits">
                        <label>{{ addon.name }}</label>
                        <span>RM {{ (addon.price || 0) | number:'1.2-2' }}</span>
                    </div>
                    <div class="info-item total">
                        <label>Total</label>
                        <span>RM {{ computeAdditionalTotal() | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
            <div class="policy-summary-card" *ngIf="quotationDetail?.insuranceType !== 'Lump Sum'">
                <div class="card-body">
                    <div class="info-item">
                        <label>SST ({{ sstRate * 100 | number:'1.0-0' }}%)</label>
                        <span>RM {{ computeSst(selectedProvider.basicPremium) | number:'1.2-2' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Service Charge</label>
                        <span>RM {{ (quotationDetail?.serviceCharge || 0) | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
            <div class="policy-summary-card"
                [ngStyle]="{'background': 'linear-gradient(135deg, #fff, #dcf0f8)', 'border-bottom': '2px solid #0056b3', 'border-top': '2px solid #0056b3'}">
                <div class="card-body">
                    <div class="info-item total">
                        <label>Grand Total</label>
                        <span>RM {{ computeGrandTotal(selectedProvider.basicPremium) | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="pay-footer">
            <div class="footer-summary">
                <div class="final-price">RM {{ computeGrandTotal(selectedProvider.basicPremium) | number:'1.2-2' }}
                    <span class="subtitle">Final price</span>
                </div>
            </div>
            <div class="footer-action">
                <button class="btn btn-pay" [disabled]="additionalBenefits.length === 0" (click)="onSave()">Pay Now</button>
            </div>
        </div>
    </div>
</div>
<app-modal [template]="modalTemplate" [state]="modalState" [size]="modalSize"></app-modal>
<ng-template #saveTemplateHeader>
    <h4>Confirm Your Payment</h4>
</ng-template>
<ng-template #saveTemplateBody><p>You’re about to pay <strong>RM {{ computeGrandTotal(selectedProvider.basicPremium) | number:'1.2-2' }}</strong>. Would you like to proceed?</p></ng-template>
<ng-template #saveTemplateFooter>
    <app-button [properties]="{name:'Cancel', type:'secondary'}" (click)="onCloseModal()"></app-button>
    <app-button [properties]="{name:'Submit', type:'success'}" (click)="onSubmit()"></app-button>
</ng-template>